import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  MailOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { UserReport } from '@services/userreport/types';

type Props = { report: UserReport };

const ReportExportStatusBadge = ({ report }: Props) => {
  const { t } = useTranslation();
  const emailSent = Boolean(report.emailSentAt) || report.progressMessage === 'email_sent';
  const state = emailSent ? 'email_sent' : report.state;
  const colors: Record<string, string> = {
    queued: 'purple',
    processing: 'blue',
    cancellation_requested: 'orange',
    ready: 'green',
    email_sent: 'cyan',
    failed: 'red',
    canceled: 'volcano',
  };
  const icons: Record<string, React.ReactNode> = {
    queued: <ClockCircleOutlined />,
    processing: <LoadingOutlined />,
    cancellation_requested: <ExclamationCircleOutlined />,
    ready: <CheckCircleOutlined />,
    email_sent: <MailOutlined />,
    failed: <CloseCircleOutlined />,
    canceled: <StopOutlined />,
  };

  return (
    <Tag color={colors[state]}>
      <span className="inline-flex items-center gap-1">
        {icons[state]}
        <span>{t(`exportReports.states.${state}`)}</span>
      </span>
    </Tag>
  );
};

export default ReportExportStatusBadge;
